var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AdminNav'),_c('div',{staticClass:"container"},[_c('div',{staticClass:"panel-body"},[(_vm.rows)?_c('div',[_c('vue-good-table',{attrs:{"title":"Articles","columns":_vm.columns,"rows":_vm.rows,"search-options":{
            enabled: true,
          },"pagination-options":{
            enabled: true,
            perPage: 10,
          }}})],1):_vm._e()])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }